import React from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LineCharttwo = () => {
    const data = [
        {
            name: '11:00 AM',
            actual: 39,
            target: 32,
        },
        {
            name: '12:00 PM',
            actual: 39,
            target: 32,
        },
        {
            name: '1:00 PM',
            actual: 39,
            target: 32,
        },
        {
            name: '2:00 PM',
            actual: 39,
            target: 32,
        },
        {
            name: '3:00 PM',
            actual: 32,
            target: 39,
        },
        {
            name: '4:00 PM',
            actual: 39,
            target: 32,
        },
        {
            name: '5:00 PM',
            actual: 0,
            target: 62,
        },
        {
            name: '6:00 PM',
            actual: 0,
            target: 62,
        },
        {
            name: '7:00 PM',
            actual: 70,
            target: 95,
        },
        {
            name: '8:00 PM',
            actual: 50,
            target: 40,
        },
        {
            name: '9:00 PM',
            actual: 102,
            target: 60,
        },
        {
            name: '10:00 PM',
            actual: 20,
            target: 98,
        },
    ];

    return (

        <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={data}
         style={{
            fontSize:"12px"
         }}
        >
          <XAxis dataKey="name" />
          <YAxis  />
          <Tooltip />
          {/* <Legend /> */}
          {/* <Bar dataKey="actual" stackId="a" fill="lightblue" /> */}
          <Bar dataKey="actual" stackId="a" fill="lightgreen" />
          <Bar dataKey="target" fill="blue" />
        </BarChart>
      </ResponsiveContainer>

    )
}

export default LineCharttwo